import {Component, OnInit} from '@angular/core';
import {AbcComplettApiService} from '../../services/abc-complett-api/abc-complett-api.service';
import { MatDialog } from '@angular/material/dialog';
import {SearchKeywordsKompetenzen} from '../../models/SearchKeywords';
import {HilfeDialogComponent} from '../ui/dialog/hilfe-dialog/hilfe-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  kompetenzen: SearchKeywordsKompetenzen[];
  keywords = '';

  constructor(
    public dialog: MatDialog,
    private apiService: AbcComplettApiService,
  ) {
    this.apiService.getSearchKeywords().subscribe(data => {
      this.kompetenzen = data.kompetenzen;
      for (const kompetenz of data.kompetenzen) {
        this.keywords += '<b>' + kompetenz.name + '</b><br/>';
        for (const branche of kompetenz.branchen) {
          this.keywords += '<a routerLink="/branche/' + branche.id + '/' + branche.name + '">' + branche.name + '</a>: ';
          let i = 0;
          for (const keyword of branche.keywords) {
            this.keywords += '<a routerLink="/branche/' + branche.id + '/' + branche.name + '">' + keyword + '</a>';
            if (i < branche.keywords.length - 1) {
              this.keywords += ', ';
            } else {
              this.keywords += '<br/>';
            }
            i++;
          }
        }
      }
    });
  }

  ngOnInit() {
  }

  openHelpOverlay() {
    this.dialog.open(HilfeDialogComponent, {
      autoFocus: false
    });
  }
}
